/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView";
import AreasOfLawOverview from "@/src/components/Sections/Generic/AreasOfLawOverview/AreasOfLawOverview";

export default function AreasOfLawStyleguide() {
  return (
    <StyleguideView title={"Rechtsbereiche"} fullWidth>
      <AreasOfLawOverview />
    </StyleguideView>
  );
}
